// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
import React from 'react';
import {
  AngelList,
  BehanceNew,
  Codepen,
  Dribble,
  FacebookNew,
  GithubNew,
  GlobeNew,
  GoodReads,
  GoogleSchollar,
  Instagram,
  Kraggle,
  LinkedInNew,
  Medium,
  ResearchGate,
  StackOverflow,
  TwitterNew,
  Vsco,
  Youtube,
} from '@components/userDocuments/editDocument/editJournal/toolset/assets/icons';

export const organizationLabels = {
  linkedIn: 'LinkedIn',
  github: 'GitHub',
  twitter: 'X',
  facebook: 'Facebook',
  dribble: 'Dribbble',
  behance: 'Behance',
  medium: 'Medium',
  kaggle: 'Kaggle',
  researchGate: 'ResearchGate',
  googleScholar: 'Google Scholar',
  stackOverflow: 'Stack Overflow',
  angelList: 'AngelList',
  youTube: 'YouTube',
  codePen: 'CodePen',
  vsco: 'VSCO',
  instagram: 'Instagram',
  goodreads: 'Goodreads',
  others: 'Others',
};

export const organizationKeyEnum = {
  LINKEDIN: 'linkedIn',
  GITHUB: 'github',
  TWITTER: 'twitter',
  FACEBOOK: 'facebook',
  DRIBBLE: 'dribble',
  BEHANCE: 'behance',
  MEDIUM: 'medium',
  KAGGLE: 'kaggle',
  RESEARCHGATE: 'researchGate',
  GOOGLESCHOLAR: 'googleScholar',
  STACKOVERFLOW: 'stackOverflow',
  ANGELLIST: 'angelList',
  YOUTUBE: 'youTube',
  CODEPEN: 'codePen',
  VSCO: 'vsco',
  INSTAGRAM: 'instagram',
  GOODREADS: 'goodreads',
  OTHERS: 'others',
};

export const organizationIcons = {
  [organizationKeyEnum.OTHERS]: <GlobeNew width="14px" height="14px" />,
  [organizationKeyEnum.LINKEDIN]: <LinkedInNew width="14px" height="14px" />,
  [organizationKeyEnum.GITHUB]: <GithubNew width="14px" height="14px" />,
  [organizationKeyEnum.TWITTER]: <TwitterNew width="14px" height="14px" />,
  [organizationKeyEnum.FACEBOOK]: <FacebookNew width="14px" height="14px" />,
  [organizationKeyEnum.DRIBBLE]: <Dribble width="14px" height="14px" />,
  [organizationKeyEnum.BEHANCE]: <BehanceNew width="14px" height="14px" />,
  [organizationKeyEnum.MEDIUM]: <Medium width="14px" height="14px" />,
  [organizationKeyEnum.KAGGLE]: <Kraggle width="14px" height="14px" />,
  [organizationKeyEnum.RESEARCHGATE]: (
    <ResearchGate width="14px" height="14px" />
  ),
  [organizationKeyEnum.GOOGLESCHOLAR]: (
    <GoogleSchollar width="14px" height="14px" />
  ),
  [organizationKeyEnum.STACKOVERFLOW]: (
    <StackOverflow width="14px" height="14px" />
  ),
  [organizationKeyEnum.ANGELLIST]: <AngelList width="14px" height="14px" />,
  [organizationKeyEnum.YOUTUBE]: <Youtube width="14px" height="14px" />,
  [organizationKeyEnum.CODEPEN]: <Codepen width="14px" height="14px" />,
  [organizationKeyEnum.VSCO]: <Vsco width="14px" height="14px" />,
  [organizationKeyEnum.INSTAGRAM]: <Instagram width="14px" height="14px" />,
  [organizationKeyEnum.GOODREADS]: <GoodReads width="14px" height="14px" />,
};
